"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileUrl = exports.sha1Translation = void 0;
var sha1Translation = function () { return ({
    sha1: '6fa8aaf2bd2b2174bbdf416f2b0f24cd0e8fe5cd',
}); };
exports.sha1Translation = sha1Translation;
var fileUrl = function () { return ({
    fileUrl: '/cb-content-service/translations/en.json',
    sha1: '6fa8aaf2bd2b2174bbdf416f2b0f24cd0e8fe5cd',
}); };
exports.fileUrl = fileUrl;
